import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "rounded-3 p-4 mb-4",
  style: {"background":"linear-gradient(104deg, #361e7d 2.4%, #403cff 112.33%)"}
}
const _hoisted_2 = { style: {"margin":"-24px -9px -27px -17px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"d-flex flex-wrap gap-2 justify-content-between align-items-center mb-1\"><span class=\"d-block mb-1\" style=\"color:#b1bbc8;\"> Today’s Payment </span><select class=\"form-select month-select form-control w-135 bg-border-color border-color\" aria-label=\"Default select example\"><option selected>All</option><option value=\"1\">Monthly</option><option value=\"1\">Yearly</option></select></div><div class=\"d-flex align-items-center mb-4\"><h3 class=\"fs-32 fw-bold text-white mb-0\">$1,528</h3><span class=\"fw-medium fs-12 border border-success px-2 rounded-pill ms-2\" style=\"background-color:#d8ffc8;color:#1e8308;\"> +5.4% </span></div>", 2)),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isClient)
        ? (_openBlock(), _createBlock(_component_apexchart, {
            key: 0,
            type: "area",
            height: "340",
            options: _ctx.paymentChart,
            series: _ctx.payment
          }, null, 8, ["options", "series"]))
        : _createCommentVNode("", true)
    ])
  ]))
}